import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import SettingsBrightnessOutlinedIcon from '@mui/icons-material/SettingsBrightnessOutlined';
import { ListItemIcon, MenuItem, Switch, ToggleButton, ToggleButtonGroup, useColorScheme } from '@mui/material';

type Mode = 'light' | 'dark' | 'system';

/** Light / Dark / Auto (match my device). Saved on this device (MUI stores it in localStorage). */
export function AppearanceSetting() {
  const { mode, setMode } = useColorScheme();
  return (
    <ToggleButtonGroup
      exclusive
      value={mode ?? 'light'}
      onChange={(_, v: Mode | null) => v && setMode(v)}
      fullWidth
      aria-label="Appearance"
    >
      <ToggleButton value="light" aria-label="Light">
        <LightModeOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
        Light
      </ToggleButton>
      <ToggleButton value="dark" aria-label="Dark">
        <DarkModeOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
        Dark
      </ToggleButton>
      <ToggleButton value="system" aria-label="Match my device">
        <SettingsBrightnessOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
        Auto
      </ToggleButton>
    </ToggleButtonGroup>
  );
}

/** Quick dark-mode switch for menus. */
export function DarkModeMenuItem() {
  const { mode, systemMode, setMode } = useColorScheme();
  const dark = (mode === 'system' ? systemMode : mode) === 'dark';
  return (
    <MenuItem onClick={() => setMode(dark ? 'light' : 'dark')} role="menuitemcheckbox" aria-checked={dark}>
      <ListItemIcon>
        <DarkModeOutlinedIcon fontSize="small" />
      </ListItemIcon>
      Dark mode
      <Switch size="small" checked={dark} tabIndex={-1} sx={{ ml: 'auto' }} slotProps={{ input: { 'aria-hidden': true } }} />
    </MenuItem>
  );
}
